import {
  afterNextRender,
  AfterViewInit,
  Component,
  DestroyRef,
  inject,
  Inject,
  InjectionToken,
  OnInit,
  PLATFORM_ID,
  signal,
  ViewChild,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { ProgressbarComponent } from '@shared/components/progressbar/progressbar.component';
import { SwiperService } from '@shared/services/swiper-config.service';
import { NgOptimizedImage } from '@angular/common';
import { SwiperComponent } from 'swiper/angular';
import { LoadingService } from '@shared/services/loading.service';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export const WINDOW = new InjectionToken<Window>('Window', {
  factory: () => window,
});

@Component({
  selector: 'iho-gallery-modal',
  standalone: true,
  providers: [
    {
      provide: WINDOW,
      useFactory: (platformId: Object) => {
        return isPlatformBrowser(platformId) ? window : {};
      },
      deps: [PLATFORM_ID],
    },
  ],
  imports: [
    CommonModule,
    MatCheckboxModule,
    FormsModule,
    SharedModule,
    ProgressbarComponent,
    MatFormFieldModule,
    MatSelectModule,
    NgOptimizedImage,
    MatDialogModule,
  ],

  templateUrl: './gallery-modal.component.html',
  styleUrls: ['./gallery-modal.component.scss'],
})
export class GalleryModalComponent implements OnInit, AfterViewInit {
  filterItemsGallery: any;
  modalData: any;
  activeFilter = false;
  configSwiperGallery: any;
  listGallery: any;
  listGalleryItems: any;
  showSlider = false;
  indexNumber = 1;
  showArrowPrev = false;
  showArrowNext = true;
  navigatorVal: boolean = false;
  destroyRef = inject(DestroyRef);
  @ViewChild('swiperGalleryEl', { static: false }) swiper?: SwiperComponent;
  cdnUrl = cdnUrl;
  resetSwiper = signal(true)
  constructor(
    @Inject(MAT_DIALOG_DATA) data: { data: any },
    public InfoService: HotelInfoUiService,
    private swiperService: SwiperService,
    public LoadingService: LoadingService,
    @Inject(WINDOW) private window: Window,
    @Inject(PLATFORM_ID) private platformId: Object,
    public dialogRef: MatDialogRef<GalleryModalComponent>
  ) {
    this.modalData = data;

    afterNextRender(() => {
      this.resetSwiper.set(false)
      setTimeout(() => this.resetSwiper.set(true), 0)
    })
  }
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.navigatorVal = !/Android|iPhone/.test(
        this.window.navigator.userAgent
      );
    }
    if (this.modalData.accommodationType == 1) {
      this.showGetGallery();
    } else {
      if (this.modalData.shabWebsitePhotos) {
        
        if (!this.modalData.allPhotos) {
          setTimeout(() => {
            this.showSlideTo(this.modalData.imageIndex);
          }, 0);
        }
        this.listGalleryItems =  this.modalData.shabWebsitePhotos
        this.LoadingService.loadingState.set(false);
        
      }
      
    }

  }
  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      let config = {
        slide: 1,
        pagination: {
          enabled: true,
          clickable: true,
        },
        navigation: false,
      };
      setTimeout(() => {
        this.configSwiperGallery = this.swiperService.SwiperConfig(config);
     }, 1000);
    }
  }
  nextSlide() {
    this.swiper?.swiperRef.slideNext(100);
  }

  previousSlide() {
    this.swiper?.swiperRef.slidePrev(100);
  }
  onSlideChange(ev: any) {
    if (ev[0].activeIndex === 0) {
      this.showArrowPrev = false;
      this.showArrowNext = true;
    } else if (ev[0].activeIndex != 0 && ev[0].isEnd == false) {
      this.showArrowPrev = true;
      this.showArrowNext = true;
    }
    if (ev[0].activeIndex != 0 && ev[0].isEnd == true) {
      this.showArrowPrev = true;
      this.showArrowNext = false;
    }
  }
  
  closeModal() {
    this.dialogRef.close();
  }

  showGetGallery() {
    this.LoadingService.loadingState.set(true);
    this.InfoService.getGalleryHotel(this.modalData.hid).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (res: any) => {
        this.listGallery = res;
        if (this.listGallery.length > 0) {
          this.LoadingService.loadingState.set(false);
          if (!this.modalData.allPhotos) {
            setTimeout(() => {
              this.showSlideTo(this.modalData.imageIndex);
            }, 0);
          }
        }
        this.listGalleryItems = res.map((item: any) => {
          return {
            ...item,
            Pictures: item.Pictures.map((pic: any) => ({
              ...pic,
              isLoading: true 
            }))
          };
        });
        this.listGalleryItems = this.listGalleryItems[0].Pictures;
     

        this.filterItemsGallery = res.map((item: any) => {
          return {
            Count: item.Count,
            Name: item.Name,
            NameEn: item.NameEn,
            active: false,
          };
        });
        this.filterItemsGallery[0].active = true;
      }
    );
  }

  showSlideTo(index: number) {
    this.showSlider = true;
    this.swiper?.swiperRef.slideTo(index);
  }
  // filterItem(item: any, ev: any) {
  //   this.listGalleryItems = this.listGalleryItems.map((item: any) => {
  //     return {
  //       ...item,
  //       isLoading: true
      
  //     };
  //   });
  //   this.showSlider = false;
  //   this.listGalleryItems = this.listGallery.filter(
  //     (filter: any) => filter.NameEn == item.NameEn
  //   )[0].Pictures;
  //   this.filterItemsGallery.forEach((element: any) => {
  //     if (element.NameEn === item.NameEn) {
  //       element.active = true;
  //     } else {
  //       element.active = false;
  //     }
  //   });
  // }
  filterItem(item: any, ev: any) {
    this.showSlider = false;

    // بازنشانی isLoading برای آیتم‌های جدید
    this.listGalleryItems = this.listGallery
      .filter((filter: any) => filter.NameEn == item.NameEn)[0]
      .Pictures.map((pic: any) => ({
        ...pic,
        isLoading: true, // مقداردهی دوباره isLoading
      }));

    this.filterItemsGallery.forEach((element: any) => {
      element.active = element.NameEn === item.NameEn;
    });
  }

  onImageLoad(item: any): void {
    if (!item.isLoading) {
      console.error('isLoading not found for item:', item);
      return;
    }

    item.isLoading = false; // حذف اسکلتون لودینگ
    this.listGalleryItems = [...this.listGalleryItems]; // تغییر مرجع آرایه
  }


  onImageError(item: any): void {
    item.Webp = `${this.cdnUrl}/images/no-image.jpg`; // تصویر پیش‌فرض
  }

}
